var map = {
	"./avispace/app/shared/object-detail/my-dspace-result-detail-element/item-detail-preview/item-detail-preview-field/item-detail-preview-field.component": [
		20104,
		[
			"common",
			"src_themes_avispace_app_shared_object-detail_my-dspace-result-detail-element_item-detail-prev-13694b"
		]
	],
	"./custom/app/shared/object-detail/my-dspace-result-detail-element/item-detail-preview/item-detail-preview-field/item-detail-preview-field.component": [
		23753,
		[
			"common",
			"src_themes_custom_app_shared_object-detail_my-dspace-result-detail-element_item-detail-previe-af3e23"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4026;
module.exports = webpackAsyncContext;